import React from 'react';
import { Typography, TypographyProps } from '../Typography';
type Props = TypographyProps;
export type SectionHeadingProps = Props;
export const SectionHeading = (props: Props) => <Typography variant="h2" textAlign="center" m={0} {...props} data-sentry-element="Typography" data-sentry-component="SectionHeading" data-sentry-source-file="index.tsx" />;